/**
 * Data source that retrieves program data from the EnterpriseProgramContext.
 */
import { useContext, useEffect } from 'react';

import { NativeDataContext } from 'bundles/promo-template/components/NativeDataContext';
import type { NativeDataRegistryEntryProgram } from 'bundles/promo-template/components/NativeDataContext';
import { useIsProgramLoading, useProgram } from 'bundles/unified-common/contexts/EnterpriseProgramContext';

function ProgramDataSource() {
  const { setNativeData } = useContext(NativeDataContext);

  const program = useProgram();
  const isProgramLoading = useIsProgramLoading();

  useEffect(() => {
    if (!isProgramLoading && program) {
      const programData: NativeDataRegistryEntryProgram | undefined = {
        id: program.id,
        slug: program.metadata.slug,
        name: program.metadata.name,
      };
      setNativeData('program', programData);
    }
  }, [setNativeData, program, isProgramLoading]);

  return null;
}

export default ProgramDataSource;
